import React from "react";
import styles from "./Hamburger.module.scss";
import classnames from "classnames/bind";

interface Props {
  isActive: boolean;
  className?: string;
  onClick: () => void;
}

const cx = classnames.bind(styles);

const Hamburger = ({ isActive, className = "", onClick }: Props) => {
  const btnStyle = cx({
    isActive: isActive,
    Hamburger: true,
    HamburgerHtx: true,
  });
  return (
    <button onClick={() => onClick()} className={classnames(btnStyle, className)}>
      <span />
    </button>
  );
};

export default Hamburger;
